import Box from '@zenbusiness/zui/Box';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { NoteStyled } from '../CheckDepositSubmissionOverview.styles';

const Note = () => (
  <NoteStyled>
    <Stack
      alignItems="center"
      direction="row"
      gap="12px"
    >
      <Box>
        <SharedAsset
          alt=""
          src="/s2/icon/calendar-fill.svg"
          width={16}
        />
      </Box>
      <Text size="sm">Keep your check for 14 days or until it clears.</Text>
    </Stack>
  </NoteStyled>
);

export default Note;
